import type { AgentId } from '../../api/agentSchemas';
import { LINES, type LineId } from './voice/lines';

/** One row of numbers shown beside what an agent says. Figures are read, never spoken. */
export type Figure = { label: string; value: string; tone?: 'negative' };

export type AgentLine = {
  agentId: AgentId;
  /** The words on screen. For a recorded line they are exactly the recording's words. */
  text: string;
  /** The recording this line is said with; a line without one is text only. */
  voz?: LineId;
  /** One muted sentence of context (a period, or why a proposal was prepared): shown, never spoken. */
  note?: string;
  figures?: readonly Figure[];
  proposalId?: string;
};

type Extras = Pick<AgentLine, 'note' | 'figures' | 'proposalId'>;

/** A recorded line: its words come from the catalog, so the screen can never say something else than the voice. */
export function spoken(agentId: AgentId, voz: LineId, extras: Extras = {}): AgentLine {
  return { agentId, voz, text: LINES[voz], ...extras };
}
